/* unplugin-vue-components disabled */import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "./App.vue?vue&type=style&index=0&id=ec4891e2&lang=scss"
import "./App.vue?vue&type=style&index=1&id=ec4891e2&lang=css"

const __exports__ = script;

export default __exports__